import { useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCreator,
  freezeCreator,
  unfreezeCreator,
  getAllCreatorsData,
} from "../../../redux/slices/creatorSlice";
import Confirmation from "../../../components/confirmation/Confirmation";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function CreatorCard({ item, debouncedSearch }) {
  const [popUp, setPopup] = useState({
    freeze: false,
    delete: false,
  });

  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.creators);

  const handleFreezeToggle = async (id) => {
    const action = item?.isFreezed ? unfreezeCreator : freezeCreator;

    try {
      const response = await dispatch(action(id));
      if (response?.payload?.code === 200) {
        toast.success(response?.payload?.message);
        setPopup((prev) => ({ ...prev, freeze: false }));
        dispatch(getAllCreatorsData({ searchVal: debouncedSearch }));
      } else {
        toast.error(
          response?.payload?.message || error?.message || "Something went wrong"
        );
      }
    } catch (err) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await dispatch(deleteCreator(id));
      if (response?.payload?.code === 200) {
        toast.success(response?.payload?.message);
        setPopup((prev) => ({ ...prev, delete: false }));
        dispatch(getAllCreatorsData({ searchVal: debouncedSearch }));
      } else {
        toast.error(
          response?.payload?.message || error?.message || "Something went wrong"
        );
      }
    } catch (err) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 px-[15px] mb-4">
      <div className="bg-[#292A2E]">
        <div className="w-full h-[279px] bg-gray-900">
          {item?.companyLogoUrl ? (
            <img
              src={item?.companyLogoUrl}
              alt={item?.name}
              className="w-full object-cover h-full"
            />
          ) : (
            <p className="text-white flex items-center justify-center h-full">
              No Company Logo
            </p>
          )}
        </div>

        <div className="p-3 min-h-[160px] flex flex-col">
          <h3 className="font-bold text-white text-left break-words">
            {item?.name}
          </h3>
          <h5 className="font-bold text-white text-left text-sm break-words">
            Email: {item?.email}
          </h5>
          {item?.companyName && (
            <h5 className="text-white text-left flex items-center gap-2">
              Company: {item?.companyName}
              <Link to={item?.companyUrl} target="_blank">
                <FaExternalLinkAlt />
              </Link>
            </h5>
          )}

          <div className="flex items-center gap-3 mt-auto w-full">
            <button
              className={`text-white px-7 py-2 rounded focus:outline-none text-sm w-full ${
                item?.isFreezed
                  ? "bg-yellow-700 hover:bg-yellow-800"
                  : "bg-green-900 hover:bg-green-800"
              }`}
              onClick={() => setPopup((prev) => ({ ...prev, freeze: true }))}
            >
              {item?.isFreezed ? "Unfreeze" : "Freeze"}
            </button>

            <button
              className="text-white bg-red-900 hover:bg-red-800 px-7 py-2 rounded focus:outline-none text-sm w-full"
              onClick={() => setPopup((prev) => ({ ...prev, delete: true }))}
            >
              Delete
            </button>
          </div>
        </div>
      </div>

      {popUp?.freeze && (
        <Confirmation
          message={item?.isFreezed ? "Unfreeze" : "Freeze"}
          buttonText={item?.isFreezed ? "Unfreeze" : "Freeze"}
          cancelDelete={() => setPopup((prev) => ({ ...prev, freeze: false }))}
          confirmDelete={() => handleFreezeToggle(item?.userId)}
        />
      )}

      {popUp?.delete && (
        <Confirmation
          message="Delete"
          buttonText="Delete"
          cancelDelete={() => setPopup((prev) => ({ ...prev, delete: false }))}
          confirmDelete={() => handleDelete(item?.userId)}
        />
      )}
    </div>
  );
}
